import { Field, Form, Formik } from "formik";
import { useState } from "react";
import { Card, Col, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import TextInput from "../../../../../components/formfields/InputField";
import { addHomeDataAction } from "../actions";
import Section from "./Section";

interface SectionValues {
  title: string;
  color: string;
  description: string;
  animatedText: string[];
  video: string;
}

interface CareerValues {
  career_header: any;
  career_description: string;
  career_button: string;
  career_button_link: string;
  section_one: SectionValues;
  section_two: SectionValues;
  section_three: SectionValues;
}
const animatedText = ["", "", "", "", ""];
const sectionState: SectionValues = {
  title: "",
  color: "af33f2",
  description: "",
  animatedText: [...animatedText],
  video: "",
};

const CareerSection = ({ props }: any) => {
  const [careerEdit, setCareerEdit] = useState<boolean>(false);
  const dispatch = useDispatch();
  const career_state = useSelector((state: any) => state?.home?.home_data);
  const [videoUploading, setVideoUploading] = useState(false);

  const careerState: CareerValues = {
    career_header: career_state?.career_header ? career_state?.career_header : "",
    career_description: career_state?.career_description ? career_state?.career_description : "",
    career_button: career_state?.career_button ? career_state?.career_button : "",
    career_button_link: career_state?.career_button_link ? career_state?.career_button_link : "",
    section_one: career_state?.section_one ? career_state?.section_one : { ...sectionState },
    section_two: career_state?.section_two ? career_state?.section_two : { ...sectionState },
    section_three: career_state?.section_three ? career_state?.section_three : { ...sectionState },
  };

  const handleCareerSubmit = (values: any) => {
    if ((!values.career_button && values.career_button_link) || (values.career_button && !values.career_button_link)) {
      toast.error("Please validate the form");
    } else if (!videoUploading) {
      const form_data = new FormData();
      form_data.append("id", "career");
      form_data.append("career_header", values.career_header);
      form_data.append("career_description", values.career_description);
      form_data.append("career_button", values.career_button);
      form_data.append("career_button_link", values.career_button_link);
      form_data.append("section_one", JSON.stringify(values.section_one));
      form_data.append("section_two", JSON.stringify(values.section_two));
      form_data.append("section_three", JSON.stringify(values.section_three));
      dispatch(addHomeDataAction(form_data, setCareerEdit, "add-career-section"));
      console.log("career_values", values);
      setCareerEdit(false);
    } else {
      toast.warning("Video upload in progress");
    }
  };

  return (
    <Formik enableReinitialize initialValues={careerState} onSubmit={handleCareerSubmit}>
      {({ values, handleChange, handleBlur, setFieldValue }) => {
        return (
          <>
            <Form autoComplete="off">
              <Card>
                <Card.Header className="d-flex justify-content-between align-items-center">
                  <h6 className={`mb-0 fs-lg ${careerEdit ? "editTitle" : ""}`}>Career Section</h6>
                  {careerEdit ? (
                    <button className="btn btn-primary" type="submit">
                      <i className="fa-regular fa-pen-to-square"></i> Save
                    </button>
                  ) : (
                    <span onClick={() => setCareerEdit(true)} className="btn btn-green">
                      <i className="fa-regular fa-pen-to-square"></i> Edit
                    </span>
                  )}
                </Card.Header>
                <Card.Body className="position-relative">
                  <div
                    className={`position-absolute w-100 h-100 start-0 top-0 zIndex-1 ${careerEdit ? "d-none" : ""}`}
                    style={{ background: "rgba(255,255,255,0.5)", cursor: "not-allowed" }}
                  ></div>
                  <Row className="gy-3">
                    <Col xs={12}>
                      <label className="form-label">Header</label>
                      <Field
                        name="career_header"
                        component={TextInput}
                        value={values.career_header}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        placeholder="Header"
                        readOnly={!careerEdit}
                        className={careerEdit ? "editField" : ""}
                      />
                    </Col>
                    <Col xs={12}>
                      <label className="form-label">Header Description</label>
                      <Field
                        name="career_description"
                        component={TextInput}
                        value={values.career_description}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        placeholder="Header description"
                        readOnly={!careerEdit}
                        className={careerEdit ? "editField" : ""}
                        multiline
                      />
                    </Col>
                    <Col sm={4}>
                      <label className="form-label">Button</label>
                      <Field
                        name="career_button"
                        component={TextInput}
                        value={values.career_button}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        placeholder="Button"
                        readOnly={!careerEdit}
                        className={careerEdit ? "editField" : ""}
                      />
                      {!values.career_button && values.career_button_link ? <div className="errorMessage">Enter button text</div> : null}
                    </Col>
                    <Col sm={8}>
                      <label className="form-label">Button Link</label>
                      <Field
                        name="career_button_link"
                        component={TextInput}
                        value={values.career_button_link}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        placeholder="Button link"
                        readOnly={!careerEdit}
                        className={careerEdit ? "editField" : ""}
                      />
                      {values.career_button && !values.career_button_link ? <div className="errorMessage">Enter button Link</div> : null}
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
              <div className="position-relative">
                <div
                  className={`position-absolute w-100 h-100 start-0 top-0 zIndex-1 ${careerEdit ? "d-none" : ""}`}
                  style={{ background: "rgba(255,255,255,0.5)", cursor: "not-allowed" }}
                ></div>
                <Section
                  section="section_one"
                  values={values}
                  props={props}
                  handleBlur={handleBlur}
                  handleChange={handleChange}
                  setFieldValue={setFieldValue}
                  sectionEdit={careerEdit}
                  setVideoUploading={setVideoUploading}
                />
                <Section
                  section="section_two"
                  values={values}
                  props={props}
                  handleBlur={handleBlur}
                  handleChange={handleChange}
                  setFieldValue={setFieldValue}
                  sectionEdit={careerEdit}
                  setVideoUploading={setVideoUploading}
                />
                <Section
                  section="section_three"
                  values={values}
                  props={props}
                  handleBlur={handleBlur}
                  handleChange={handleChange}
                  setFieldValue={setFieldValue}
                  sectionEdit={careerEdit}
                  setVideoUploading={setVideoUploading}
                />
              </div>
            </Form>
          </>
        );
      }}
    </Formik>
  );
};

export default CareerSection;
